import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { far } from "@fortawesome/free-regular-svg-icons"
import { fab } from "@fortawesome/free-brands-svg-icons"

// Pro-only names stored on case types / hardcoded in the GUI. Use the closest free solid glyph.
const PRO_FALLBACKS = {
  "file-search": "magnifying-glass",
  analytics: "chart-line",
  abacus: "calculator",
  acorn: "seedling",
  "cabinet-filing": "folder",
  "calendar-exclamation": "calendar-xmark",
  "car-building": "warehouse",
  "car-mechanic": "screwdriver-wrench",
  "chart-network": "network-wired",
  "comment-alt-medical": "comment-medical",
  dagger: "bolt",
  ear: "headphones",
  "file-plus": "file-circle-plus",
  "garage-open": "warehouse",
  "head-side-headphones": "headphones",
  "steering-wheel": "car",
  "user-visor": "user-secret",
  "users-class": "users",
  "person-carry": "people-carry-box",
  boxes: "boxes-stacked",
}

function uniqueIcons(defs) {
  const byId = {}
  defs.forEach(function (def) {
    if (!def || !def.iconName || !def.icon) return
    byId[def.prefix + ":" + def.iconName] = def
  })
  return Object.keys(byId).map(function (key) {
    return byId[key]
  })
}

function exportKeyToIconName(key) {
  if (key.indexOf("fa") !== 0) return null
  return key
    .slice(2)
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1-$2")
    .toLowerCase()
}

function iconsFromPack(pack) {
  const icons = []
  Object.keys(pack).forEach(function (key) {
    const def = pack[key]
    if (!def || !def.iconName || !def.icon) return
    icons.push(def)
    const aliases = def.icon[2]
    if (Array.isArray(aliases)) {
      aliases.forEach(function (alias) {
        if (typeof alias === "string" && alias !== def.iconName) {
          icons.push(Object.assign({}, def, { iconName: alias }))
        }
      })
    }
    const fromExport = exportKeyToIconName(key)
    if (fromExport && fromExport !== def.iconName) {
      icons.push(Object.assign({}, def, { iconName: fromExport }))
    }
  })
  return uniqueIcons(icons)
}

function remapPrefix(icons, prefix) {
  return icons.map(function (def) {
    return Object.assign({}, def, { prefix: prefix })
  })
}

function fillMissingPrefix(sourceIcons, existingIcons, prefix) {
  const have = {}
  existingIcons.forEach(function (def) {
    have[def.iconName] = true
  })
  return sourceIcons
    .filter(function (def) {
      return !have[def.iconName]
    })
    .map(function (def) {
      return Object.assign({}, def, { prefix: prefix })
    })
}

function findByName(icons, name) {
  for (var i = 0; i < icons.length; i++) {
    if (icons[i].iconName === name) return icons[i]
  }
  return null
}

function proFallbackIcons(solidIcons) {
  const extras = []
  Object.keys(PRO_FALLBACKS).forEach(function (missingName) {
    const source = findByName(solidIcons, PRO_FALLBACKS[missingName])
    if (!source) return
    ;["fas", "far", "fal"].forEach(function (prefix) {
      extras.push(Object.assign({}, source, { prefix: prefix, iconName: missingName }))
    })
  })
  return extras
}

const solidIcons = iconsFromPack(fas)
const regularIcons = iconsFromPack(far)
const brandIcons = iconsFromPack(fab)
const fallbackIcons = proFallbackIcons(solidIcons)

// Pro Light (fal) is not available without a Font Awesome subscription.
// Reuse free solid under fal. Register FA5 aliases and Pro-only fallbacks so
// stored case-type icons and hardcoded GUI names still resolve.
library.add.apply(
  library,
  solidIcons
    .concat(regularIcons)
    .concat(brandIcons)
    .concat(remapPrefix(solidIcons, "fal"))
    .concat(fillMissingPrefix(solidIcons, regularIcons, "far"))
    .concat(fallbackIcons)
    .concat(remapPrefix(solidIcons, "default"))
)

export { library, PRO_FALLBACKS }
